<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { getConfig } from '@/app/config'
import { useAuthStore } from '@/app/stores/auth'
import { collectWidgets, type GlobalWidgetContext, type RegisteredWidget } from '@/app/widgets'

/**
 * The global widget slot (wp/shell OPEN-16; `src/app/widgets.ts`): outside the routes and the layouts, so a widget
 * stays mounted across navigations. Each module widget renders while its `when` answers `true`.
 */
const props = withDefaults(defineProps<{ widgets?: readonly RegisteredWidget[] }>(), { widgets: () => registered })

const auth = useAuthStore()
const route = useRoute()

const context = computed<GlobalWidgetContext>(() => ({
  signedIn: auth.session !== null,
  userType: auth.userType,
  software: auth.currentSoftware,
  devMode: getConfig().devMode,
  path: route.path,
  layout: route.meta.layout ?? 'vertical',
}))
const shown = computed(() => props.widgets.filter((widget) => widget.when(context.value)))
</script>

<script lang="ts">
const registered = collectWidgets()
</script>

<template>
  <component :is="widget.component" v-for="widget in shown" :key="widget.id" />
</template>
